<template>
    <div>
        <h1 class="leading-none font-700 text-2xl md:text-3xl lg:text-4xl mb-4 lg:mb-8">{{ $t(fieldLabel) }} </h1>

        <template v-if="type == 'Dive' && additionalCharges && additionalCharges.length == 1" >
            <div class="mb-4 lg:mb-8">{{ getTranslatedLabelByIndex(0) }}</div>                     
            <div class="additional--charges">
                <div class="mb-4 lg:mb-8">
                    <label>
                        <div class="flex">
                            <div class="font-700 uppercase mr-4">{{$t("additionalCharges.numberOfPersons")}}</div>
                        </div>
                        <div class="py-4 px-8"></div>
                        <div class="px-8 w-64">
                            <input v-model="divePersons" min="0" max="99" type="number">
                        </div>
                    </label>
                </div>
            </div>
            <div class="additional--charges">
                <div class="mb-4 lg:mb-8">
                    <label>
                        <div class="flex">
                            <div class="font-700 uppercase mr-4">{{$t("additionalCharges.amountOfDaysUnlimitedAir")}}</div>
                        </div>
                        <div class="py-4 px-8"></div>
                        <div class="px-8 w-64">
                            <input v-model="diveDays" min="0" max="99" type="number">
                        </div>
                    </label>
                </div>
            </div>
        </template>
        <div v-else v-for="(ac, i) of additionalCharges" :key="i" class="additional--charges" v-show="showAdditionalChargeByIndex(i) && !isFilteredOut(ac)" >
            <div class="mb-4 lg:mb-8">
                <label>
                    <div class="flex" >                        
                      <div v-if="!isCustomCharge(ac)" v-show="ac.selection_type === 'only_one'" class="mr-2">
                          <input :id="CreatePropertyId('acCheckboxQuantity', ac.id)" v-model="ac.is_selected" type="checkbox" :disabled="checkIfAdditionalChargeIsReadOnlyByIndex(i)" />
                      </div>
                      <div v-if="!isCustomCharge(ac)" class="font-700 uppercase mr-4">{{getTranslatedLabelByIndex(i)}}</div>
                      <div v-if="!isCustomCharge(ac) && ac.charge_type == 'percent'">{{getAdditionalChargeRateByIndex(i)}}%</div>
                      <div v-else-if="!isCustomCharge(ac)">{{getAdditionalChargeRateByIndex(i) | toCurrency}} {{getAdditionalChargeTypeByIndex(i)}}</div>
                    </div>
                    <FullCoveragePlanTable v-if="ac.label === 'Full Coverage Plan'" :id="CreatePropertyId('acCheckboxQuantity', ac.id)" :ac="ac" :disabled="checkIfAdditionalChargeIsReadOnlyByIndex(i)" />
                    <BeachPremiumPackage v-if="ac.label === 'Beach Premium Package' || ac.label === 'Premium Beach Package'" :id="CreatePropertyId('acCheckboxQuantity', ac.id)" :ac="ac" :disabled="checkIfAdditionalChargeIsReadOnlyByIndex(i)" />
                    <div v-if="!isCustomCharge(ac)" v-html="getTranslatedShortDescriptionByIndex(i)" class="py-4 px-8"></div>
                    <div v-show="ac.selection_type === 'multiple'" class="px-8 w-64">
                        <input min="0" max="99" :id="CreatePropertyId('acSelectQuantity', ac.id)" type="number" v-model="ac.quantity"/>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import HtmlPropertyHelper from '@/mixins/HtmlPropertyHelper';
    import DateTimeHelper from '@/mixins/DateTimeHelper';
    import CaagApi from '@/mixins/CaagApi';
    import ReservationHelper from '@/mixins/ReservationHelper';
    import i18n from '../locale/languages';
    import FullCoveragePlanTable from '@/components/FullCoveragePlanTable';
    import BeachPremiumPackage from '@/components/BeachPremiumPackage.vue';

    export default {
        name: 'AdditionalCharges',
        mixins: [HtmlPropertyHelper, DateTimeHelper, CaagApi, ReservationHelper],
        props: {
            fieldLabel: String,
            reservation: Object
        },
        components: {
    FullCoveragePlanTable,
    BeachPremiumPackage
},
        data: () => ({
            discountCode: null,
            divePersons:0,
            diveDays:0
        }),
        computed: {
            diveDescription:function(){
                if(!(this.additionalCharges && this.additionalCharges[0])) return ""
                return this.additionalCharges[0].description.replaceAll('{price}',this.$options.filters.toCurrency(this.getAdditionalChargeRateByIndex(0)))                
            },
            currentCarId: function() {
                if ( this.reservation.car ) {
                    return this.reservation.car.id;
                }
                else {
                    return null;
                }
            }
        },
        mounted() {
          this.initializeAdditionalCharges();
        },
        watch: {
            divePersons(newQty,oldQty){this.calcDivePrice()},
            diveDays(newQty,oldQty){this.calcDivePrice()},
            reservation: {
                deep: true,
                handler() {
                    if ( this.reservation.discountCode != this.discountCode ) {
                        this.discountCode = this.reservation.discountCode;
                        this.getAdditionalChargesPrices(this.reservation);
                    }
                }
            },
            additionalCharges: {
                deep: true,
                handler() {
                    this.$emit('setAdditionalCharges', this.additionalCharges);
                    this.getAdditionalChargesPrices(this.reservation);
                }
            },
            availableAdditionalCharges: {
                deep: true,
                handler() {
                     this.$emit('setAvailableAdditionalCharges', this.availableAdditionalCharges);
                     this.getAdditionalChargesPrices(this.reservation);
                }
            },
            additionalChargesPrices: function(val) {
                val.selectedAdditionalCharges = val.selected_additional_charges;
                this.$emit('setAdditionalChargesPrices', val);
            },
            errors: function(val) {
                this.$emit('setErrors', val);
            }
        },
        methods: {
            calcDivePrice(){
                this.additionalCharges[0].quantity = parseInt(this.divePersons) * parseInt(this.diveDays)
                this.$emit('setAdditionalCharges', this.additionalCharges);
                this.getAdditionalChargesPrices(this.reservation);
            },
            initializeAdditionalCharges() {
                this.getAvailableAdditionalCharges(this.currentCarId);        
                this.getAdditionalCharges(this.reservation);
            },
            // Temporary fix because start_date and end_date are not working in CAAG
            isFilteredOut(ac) {
                var acp = this.availableAdditionalCharges.find(aac => aac.id == ac.id);
                if (acp.start_date != null && new Date(acp.start_date) > new Date(this.reservation.pickupDateTime)) {
                    return true;
                }
                if (acp.end_date != null && new Date(acp.end_date) < new Date(this.reservation.returnDateTime)) {
                    return true;
                }

                return false;
            },
            getAdditionalChargeById(id) {
                return this.additionalCharges.find((ac) => {
                    return ac.id == id;
                });
            },
            getAdditionalChargeByIndex(index) {
                return this.additionalCharges[index];
            },
            showAdditionalChargeByIndex(index)         {
                var ac = this.getAdditionalChargeByIndex(index);
                if ( ac ) {
                    var aac = this.getAvailableAdditionalChargeById(ac.id);
                    if ( aac ) {
                        if ( ac.mandatory ) {
                            return false;
                        }
                        else if ( ac.selection_type == 'only_one' && this.NumberOfDays <= 2 ) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            },
            getTranslatedLabelByIndex(index) {
                var ac = this.getAdditionalChargeByIndex(index);
                if ( ac ) {
                    var aac = this.getAvailableAdditionalChargeById(ac.id);
                    if ( aac ) {
                        var label = aac.label_for_website[i18n.locale];
                        if ( label == '' ) {
                            label = aac.label_for_website[i18n.fallbackLocale];
                        }

                        if (label == null || label == '' ) {
                            label= aac.name
                        }


                        return label;
                    }
                }
            },
            getTranslatedShortDescriptionByIndex(index) {
                var ac = this.getAdditionalChargeByIndex(index);
                if ( ac ) {
                    var aac = this.getAvailableAdditionalChargeById(ac.id);
                    if ( aac ) {
                        var shortDescription = aac.short_description_for_website[i18n.locale];
                        if ( shortDescription == '' ) {
                            shortDescription = aac.short_description_for_website[i18n.fallbackLocale];
                        }

                        return shortDescription;
                    }
                }
            },
            getAdditionalChargeRate(ac) {
                return parseFloat(ac.base_price.amount);
            },
            getAdditionalChargeRateById(id) {
                var ac = this.getAdditionalChargeById(id);
                if ( ac ) {
                    return this.getAdditionalChargeRate(ac);
                }
            },
            checkIfAdditionalChargeIsReadOnlyByIndex(index) {
                var ac = this.getAdditionalChargeByIndex(index);
                if (ac && ac.mandatory) {
                    return true;
                }
                else {
                    return false;
                }
            },
            getAdditionalChargeRateByIndex: function(index) {
                var ac = this.getAdditionalChargeByIndex(index);
                if ( ac ) {
                    return this.getAdditionalChargeRate(ac);
                }
            },
            getAdditionalChargeTypeByIndex: function(index) {
                var ac = this.getAdditionalChargeByIndex(index);
                if ( ac ) {
                    return this.$t("additionalCharges."+ ac.charge_type);
                }
            },
            isCustomCharge(ac) {
                return ac.label === "Full Coverage Plan" || ac.label === "Beach Premium Package" || ac.label === "Premium Beach Package";
            },
            setDiscountCode(val) {
                this.discountCode = val;
            }
        }
    }
</script>